import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducer';

const storeInit = () => {
  if (!window._store) {
    const store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          // serializableCheck: {
          //   ignoredActionTypes: [],
          //   ignoredPaths: [],
          // },
          // immutableCheck: true,
          // TODO: turn on check options after react/redux migration to newest version.
          serializableCheck: false,
          immutableCheck: false,
        }),
      devTools: {
        name: "Adagio Frontend",
        trace: true,
        traceLimit: 25
      },
    });

    window._store = store;
  }

  return window._store;
};

export default storeInit();
